@if (reportReady && isBMSTestEnv) {
    <powerbi-report [embedConfig]='reportConfig' [cssClassName]="powerBiClass" [phasedEmbedding]='powerBIPhasedEmbedding' [eventHandlers]='powerBiEventHandlers'></powerbi-report>
}
